import { CLOSE_NOTIFICATION, DISPLAY_NOTIFICATION } from 'notification/constants';

export const displayNotification = (msgText, notificationType, showCloseBtn, id, delayTime) => ({
  type: DISPLAY_NOTIFICATION,
  msgText,
  notificationType,
  showCloseBtn,
  id,
  timestamp: Date.now(),
  delayTime,
});

export const closeNotification = (id) => ({ type: CLOSE_NOTIFICATION, id });

export const handleNotification = (msgText, type, showCloseBtn, autoClose) => {
  const min = 10000;
  const max = 0;
  const rnd = min + Math.random() * (max - min);

  return (dispatch) => {
    dispatch(displayNotification(msgText, type, showCloseBtn, rnd, 0));
    if (autoClose) setTimeout(() => void dispatch(closeNotification(rnd)), 5000);
  };
};
